import React from 'react'
import Box from '@mui/material/Box'

const StepperLine = ({ active }) => {
  return (
    <Box
      height={20}
      width={3}
      bgcolor={active ? 'alternate.main' : 'gray-line.main'}
      marginLeft="26px"
      sx={{ transform: 'translateX(-50%)' }}
    />
  )
}

export default StepperLine
